import React from 'react';

export const initXml = (
  <xml xmlns="https://developers.google.com/blockly/xml">
    <block type="createc_retiro_initial_block" deletable="false" />
  </xml>
);
/* eslint-disable */
export const categoryXml = (
  <React.Fragment>
    <category id="Control" name="%{BKY_LANG_CATEGORY_CONTROLS}" iconclass="control" expandedclass="control-extended">
      <label text="%{BKY_LANG_CATEGORY_CONTROLS}" />
      <block type="controls_if_no_else" />
      <block type="controls_repeat_educabot">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block>
    </category>


    <category id="Entradas" name="%{BKY_LANG_CATEGORY_COMPARISON}" iconclass="inputsDigi" expandedclass="inputsDigi-extended">
      <label text="%{BKY_LANG_CATEGORY_COMPARISON}" />
      <block type="createc_logic_compare_ldr">
        <value name="A">
          <block type="train_createc_ciudad_ldr" />
        </value>
      </block>
      <block type="createc_logic_compare_train">
        <value name="A">
          <block type="createc_train_passing" />
        </value>
      </block>
    </category>

    <category id="Salidas" name="%{BKY_LANG_CATEGORY_LIGHTNING}" iconclass="outputs" expandedclass="outputs-extended">
      <label text="%{BKY_LANG_CATEGORY_LIGHTNING}" />
      <block type="createc_retiro_restore_electricity" />
      <block type="createc_retiro_luminaria_zona2" />
      <block type="createc_retiro_blinking_lights" />
    </category>

    <category id="Motores" name="%{BKY_LANG_CATEGORY_MOTION}" iconclass="motors" expandedclass="motors-extended">
      <label text="%{BKY_LANG_CATEGORY_MOTION}" />
      <block type="createc_retiro_train_frequency">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block>
      {/* <block type="createc_retiro_train_frequency_sanmartin">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block>
      <block type="createc_retiro_train_frequency_mitre">
        <value name="TIMES">
          <shadow type="math_number">
            <field name="NUM">10</field>
          </shadow>
        </value>
      </block> */}
      <block type="createc_retiro_train_service" />
      {/* <block type="createc_retiro_train_service_sanmartin" />
      <block type="createc_retiro_train_service_mitre" /> */}
      <block type="createc_retiro_barriers" />
    </category>
  </React.Fragment>
);
/* eslint-enable */
